<template>
    <div class="flex flex-col">
        <div class="mb-md">
            <h1 class="m-0 text-md text-neutral-darkest">{{ address.full_address }}</h1>
        </div>

        <div
            v-if="address.latest_interaction && isForDeliveryProject"
            class="mb-xl"
        >
            <font-awesome-icon
                :icon="address.latest_interaction.icon"
                :class="address.latest_interaction.color"
            />
            <span :class="address.latest_interaction.color">{{ address.latest_interaction.label }}</span>
        </div>

        <table class="table condensed striped">
            <tbody>
                <tr>
                    <td>Fastighetstyp</td>
                    <td>{{ address.address_type_labels[address.address_type] }}</td>
                    <td>
                        <button
                            class="float-right btn-icon"
                            @click="$emit('changeView', 'edit-address-details', 'address_type')"
                        >
                            <font-awesome-icon icon="pencil" size="sm" />
                        </button>
                    </td>
                </tr>
                <tr>
                    <td>Access ID</td>
                    <td>
                        {{ address.reference_number }}
                    </td>
                    <td />
                </tr>
                <tr>
                    <td>HP Distance</td>
                    <td>
                        {{ address.hp_distance ? address.hp_distance : '-' }}
                        ({{ address.hp_unit ? address.hp_unit : 'unknown' }})
                    </td>
                    <td />
                </tr>
                <tr>
                    <td>Status</td>
                    <td>{{ address.is_signed ? 'Signerad' : 'Osignerad' }}</td>
                    <td />
                </tr>
            </tbody>
        </table>

        <div v-if="isForDeliveryProjectAndHasDeliveryProject" class="flex flex-col justify-between mt-2xl">
            <detach-address-button
                :delivery-project-id="address.delivery_project_id"
                :address-id="address.id"
            />

            <a
                class="btn btn-lg is-ghost mt-md"
                :href="route('admin.delivery-projects.addresses.show', [address.delivery_project_id, address.id])"
            >
                Visa adress
            </a>
        </div>
        <div v-else-if="isForDeliveryProject" class="mt-lg">
            <alert
                type="message"
                icon="info-circle"
                initial-body="Adressen saknar leveransprojekt"
            />
        </div>
    </div>
</template>
<script>
    import DetachAddressButton from './DetachAddressButton';

    export default {
        components: { DetachAddressButton },
        props: {
            address: {
                type: Object,
                required: true,
            },
            projectType: {
                type: String,
                default: 'deliveryProject',
            },
        },
        computed: {
            isForDeliveryProject() {
                return this.projectType === 'deliveryProject';
            },
            isForDeliveryProjectAndHasDeliveryProject() {
                return this.isForDeliveryProject && this.address.delivery_project_id;
            },
        },
    };
</script>
